import { IAttachmentWithData, IAudit, RecipientInformation, TemplateType } from '@alberta/konexi-shared';
import { createObject } from 'src/app/common/tracking/object-creator';
import { ignore, tracked } from 'src/app/common/tracking/tracker';
import { BaseViewModel } from 'src/app/common/viewmodel/base-view-model';

import { AuthorizedKiwiInstitution } from '@alberta/konexi-shared/dist/institution/authorized-kiwi-institution';
import { AuditNodeViewModel } from './audit-node-view-model';

export class AuditViewModel extends BaseViewModel implements IAudit {
  emailAddresses: string[];
  @ignore(true)
  hash: {
    [nodeId: string]: string;
  };

  completed: boolean;
  _id = '';
  archived: boolean;
  timestamp: Date;

  @ignore(true)
  templateId: string;

  @ignore(true)
  displayType: number;

  @tracked({ factory: createObject(AuditNodeViewModel) })
  auditNodes: AuditNodeViewModel[] = [];
  @ignore(true)
  permissions;

  createdBy: string;
  createdUtc: string;
  updatedUtc: string;
  completedUtc: string;

  @ignore(true)
  header;

  patientId;

  @ignore(true)
  groupByValue;

  @ignore(true)
  type: TemplateType;
  therapyId: number;
  therapyTypeId: number;
  woundLocation: string;

  regionId: string;

  additionalInfo: string;
  createdAt: Date;
  updatedAt: Date;
  updatedBy: string;
  optimizedFormularValidation: boolean;
  images?: IAttachmentWithData[];
  entityType?: string;
  faxInfo?: RecipientInformation;
  emailInfo?: RecipientInformation;
  draft?: boolean;
  authorizedKiwiInstitutions?: AuthorizedKiwiInstitution[] = [];
}
